import _ from 'lodash'

export const eventId = state => state.eventId
export const isBadEvent = state => state.isBadEvent

export const teams = state => {
    return state.event.teams || []
}

export const hasErrors = state => !!state.workspace && !!state.workspace.errors.length

export const getErrorsByField = state => ({ fieldName }) => {
    return state.workspace
        && state.workspace.errors.filter(error => error.fieldName === fieldName)
        || []
}

export const getErrorsByEntry = state => ({ entry }) => {
    return state.workspace
        && state.workspace.errors.filter(error => error.entry === entry)
        || []
}

export const getMappedColumnByField = state => ({ fieldName }) => {
    const mapping = state.workspace.fieldMappings.find(mapping => mapping.fieldName === fieldName)
    return mapping && mapping.columnName || null
}

export const fieldMappings = state => {
    return state.workspace.fieldMappings
}

export const entries = state => {
    return state.workspace.entries
}

export const unmappedFields = state => {
    const unmappedFields = state.fields.filter(field => {
        const mapping = state.workspace.fieldMappings.find(mapping => mapping.fieldName === field.name)
        return !mapping
    })

    return unmappedFields
}

export const hasUnmappedFields = state => {
    return !!unmappedFields(state).length
}

export const hasUnmappedRequiredFields = (state) => {
	return !!unmappedFields(state).filter(field => field.required).length
}

export const hasErroneousRequiredFields = (state, getters) => {
    return _(state.fields)
        .filter('required')
        .flatMap(field => getters.getErrorsByField({ fieldName: field.name }))
        .value()
        .length > 0
}

export const getRequiredFields = (state, getters) => {
    return _(state.fields)
        .filter('required')
        .flatMap(field => field.name)
        .value()
}

export const hasLoadedEvent = state => {
    return !!state.event
}

export const eventName = state => state.event.name

export const eventImageUrl = state => {
    const event = state.event
    const image = event.images.find(i => i.isProfile)
    return image && image.url || null
}

export const eventLocation = state => {
    const event = state.event
    return [event.locationCity, event.locationState].filter(Boolean).join(', ')
}

function formatSport(sport, gender) {
    const sportName = _.startCase(sport.name)
    const genderName = { male: "Boys'", female: "Girls'" }[gender] || ''

    return `${genderName} ${sportName}`
}

export const eventSportId = state => state.event.sport.id
export const eventGender = state => state.event.gender
export const eventSportName = state => formatSport(state.event.sport, state.event.gender)
export const organizationName = state => state.me.organization.name
export const organizationSportName = state => formatSport(state.me.organization.sport, state.me.organization.gender)

export const eventStartDate = state => state.event.startDate
export const eventEndDate = state => state.event.endDate

export const availablePositions = state => state.event.sport.positions

export const getTeamName = state => teamId => {
    const team = getTeamById(state, teamId)
    return team && team.name || null
}

const getTeamById = (state, teamId) => {
    return state.event.teams.find(t => t.id === teamId)
}

export const fields = state => state.fields
export const isValidating = state => !!state.workspace.validationRequest && !state.workspace.validationRequest.isFinished

export const isRetrievingAccounts = state => state.accountRetrieval && !state.accountRetrieval.isFinished
export const accountRetrievalErrors = state => state.accountRetrieval && state.accountRetrieval.errors || []
export const availableAccounts = state => state.auth.accounts || []
export const hasRetrievedAccounts = state => !!state.auth.accounts
export const hasAvailableAccounts = state => state.auth.accounts && state.auth.accounts.length

export const isSubmittingLogin = state => state.loginSubmission && !state.loginSubmission.isFinished
export const loginSubmissionAccountId = state => state.loginSubmission && state.loginSubmission.accountId || null

export const isSubmittingRegistration = state => !!state.registrationSubmission && !state.registrationSubmission.isFinished
export const registrationSubmissionErrors = state => state.registrationSubmission && state.registrationSubmission.errors || []

export const integratedAccountId = state => state.auth.integratedIdentity.accountId
export const isIntegrated = (state) => !!state.auth.integratedIdentity
export const isNonIntegrated = (state) => !!state.auth.nonIntegratedIdentity
export const isIdentified = state => !!state.auth.integratedIdentity || !!state.auth.nonIntegratedIdentity

export const isTheWrongSport = state => {
    return state.me && state.event && (
        state.me.organization.sport.id != state.event.sport.id ||
        state.me.organization.gender != state.event.gender
    )
}

export const hasRetrievedOwnInfo = state => !!state.me
export const hasRetrievedClubAthletes = state => !!state.me

export const clubId = state => state.me.organization.id
export const clubTeams = state => state.me.organization.teams
export const clubAthletes = state => state.me.organization.athletes

export const csv = state => state.workspace.csv
export const hasCsv = state => !!state.workspace && !!state.workspace.csv

export const hasAthlete = state => athleteId => !!state.workspace.entries.find(e => e.id === athleteId)

export const isSubmittingRoster = state => !!state.workspace && state.workspace.isSubmitting
export const isFinished = state => !!state.workspace && state.workspace.wasSubmitted
export const hadSubmissionError = state => state.hadSubmissionError